import { useEffect, useState } from "react";
import { useAppealContext } from "api/settings/appeal/AppealProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import { isHexa } from "utils/functions";
import HexaColor from "core/hexa-color/HexaColor";
import Button from "core/buttons/button/Button";

export default function AdminAppeal({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    appealByIdGetter,
    appealCreate,
    appealDeleteById,
    appealList,
    appealListGetter,
    appealPerId,
    appealUpdateById,
  } = useAppealContext();

  const appealForm = [
    { col: "en", mandatory: true, isMissingValue: null },
    { col: "fr", mandatory: true, isMissingValue: null },
    { col: "hexa", mandatory: true, isMissingValue: null },
  ];
  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    appealListGetter();
  }, [appealListGetter]);

  useEffect(() => {
    if (id) {
      appealByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (appealId) =>
    setDeleteData(appealList.find((e) => e.id === appealId));

  const validateDelete = async (appealId) => {
    try {
      await appealDeleteById(appealId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      appealCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      appealUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  const formatList = (list) =>
    list.map((elm) => ({
      ...elm,
      hexa: isHexa(elm?.hexa) ? <HexaColor value={elm.hexa} /> : "",
    }));
  const formatAppeal = (appeal) => ({
    ...appeal,
    hexa: isHexa(appeal.hexa) ? <HexaColor value={appeal.hexa} /> : "",
  });

  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.APPEAL}
        entityPerId={appealPerId}
        formattedEntity={formatAppeal(appealPerId)}
        list={formatList(appealList)}
        inputs={appealForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.APPEAL}
        />
      </div>
    </div>
  );
}
